
import { useEffect } from 'react'
import Select from 'react-select'
import { WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const WardNameDataDDL = (props) => {
    const { WardName, setWardName, Flag, rowData, item, IsDisabled, isClearable, HWard, WLable, SectorName, setSectorName, DashProjectTypeId } = props
    // console.log(rowData)
    const userDetails = useAuthState();
    const { UserID, RoleID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token, handleWardNameDDL }
        dispatch(WardNameDDLAPI({ data }))
    }, [])
    const { WardDDLData } = useSelector(state => state.WardNameDDLData)

    // useEffect(() => {
    //     handleWardNameDDL()
    // }, [])
    // console.log('first', WardName.ID)
    const handleWardNameDDL = (WardDDLData) => {
        if (WardDDLData && WardDDLData.table && WardDDLData.table.length > 0) {
            let list = WardDDLData.table.map((item, index) => ({
                value: item.id,
                label: item.wardName,
            }))
            setWardName({
                DDL: list,
                // ID: Flag === 'Update' ? rowData.m_WardID : Flag === 'Ward' ? list[0].value : HWard ? HWard : RoleID == '16' ? list.value : 0,
                // Label: Flag === 'Update' ? rowData.wardName : Flag === 'Ward' ? list[0].label : WLable ? WLable : RoleID == '16' ? list.label : 'Select...'
                ID: (RoleID == '16' || DashProjectTypeId == '1') ? 0 : Flag === 'Update' ? rowData.m_WardID : Flag === 'Ward' ? list[0].value : HWard ? HWard : 0,
                Label: (RoleID == '16' || DashProjectTypeId == '1') ? "Select..." : Flag === 'Update' ? rowData.wardName : Flag === 'Ward' ? list[0].label : WLable ? WLable : 'Select...'
            })
        }
        else {
            setWardName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Ward Name {Flag && <AstricSign />} </b></label>
            <Select
                isClearable={isClearable === false ? false : true}
                // isRtl={isRtl}
                // className='ddl_width3'
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                isSearchable
                maxMenuHeight={115}
                value={{ value: WardName.ID, label: WardName.Label }}
                onChange={(e) => {
                    e ?
                        setWardName({ ...WardName, ID: e.value, Label: e.label })
                        :
                        setWardName({ ...WardName, ID: 0, Label: "Select..." })
                    { setSectorName && setSectorName({ ...SectorName, ID: 0, Label: "Select..." }) }

                }}
                options={WardName.DDL}
            />
        </div>
    )
}